import { benchmarkIsActive, benchmarkIncludedInWeightedWork } from '../../../../shared/models/benchmark-policy.model';
import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Notifications
import { HotToastService } from '@ngneat/hot-toast';
import { JobTypeDocument } from '../../../../shared/models/jobTypeDocument.model';

// import { CreateJobTypeComponent} from './create-job-type.component';

import { BsModalService } from 'ngx-bootstrap/modal';
import { JobType } from '../../../../shared/models/jobType.model';
import { SystemLogType } from 'src/app/shared/models/systemLogType.model';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';
import { SystemLogTypeDataSectorType } from 'src/app/shared/models/systemLogTypeDataSectorType.model';
import { SystemLogTypeBenchmark } from 'src/app/shared/models/systemLogTypeBenchmark.model';

@Component({
  selector: 'app-log-type-benchmark-create',
  templateUrl: './log-type-benchmark-create.component.html',
  styleUrls: ['./log-type-benchmark-create.component.scss']
})
export class LogTypeBenchmarkCreateComponent implements OnInit {
  readonly benchmarkIsActive = benchmarkIsActive;
  readonly weightedIncluded = benchmarkIncludedInWeightedWork;


  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  model: SystemLogTypeBenchmark;
  get_latest_log_type_benchmark_id: Object;
  system_log_types: any;
  brand_types: any;
  user_levels: any;

  constructor(

    private http: HttpClient,
    private _demoService: DemoService,
    private route: ActivatedRoute,
    private router: Router,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private modalService: BsModalService, viewRef: ViewContainerRef,
    public gfunc: GlobalFunctionsService
  ) { }

  ngOnInit(): void {
    this.model = new SystemLogTypeBenchmark;
    this.model.unit_time_duration_ms = 0;
    this.model.is_active = 1;
    this.getSystemLogTypes();
    this.getBrandTypes();
    this.getUserLevels();
  }



  createSystemLogTypeBenchmark(model) {
    // console.log(model);
        this._demoService.createSystemLogTypeBenchmark({...model, is_active: benchmarkIsActive(model.is_active) ? 1 : 0}).subscribe(
             data => {  this.get_latest_log_type_benchmark_id = data; // this is the retuned json upon creation.
          
              this.toastr.success('Log Type Benchmark Created');
     
             this.closeParentModel.emit();
      
            //  this.gfunc.globalViewSystemLogTypeBenchmarksSkipRoute();
   
   
             // CreateJobTypeComponent.returned.next(false);
               //  return true;
             },
             error => {
               this.toastr.error('Adding Type Benchmark Failed :: Please try again!');
               // console.log(Observable.throw(error));
               // return Observable.throw(error);
             }
        );
        }




        getSystemLogTypes() {
          this._demoService.getSystemLogTypes().subscribe(
             data => { this.system_log_types = data;  },
             err => console.error(err),
              () => {
                console.log('done loading System Log Types')
               // this.collection = Array (this.job_types, this.job_type_locations); // collection of all data
               // let mappedJSON = JSON.parse(mapped);
               // console.log('Mapped JSON Array: ' + mappedJSON);
              }
                );
         }



         getBrandTypes() {
          this._demoService.getBrandBrandTypes().subscribe(
             data => { this.brand_types = data; },
             err => console.error(err),
             // () => console.log('done loading candidate for update')
           );
         }
    


         getUserLevels() {
          this._demoService.getUserLevels().subscribe(
            data => { this.user_levels = data;
             let res = data[0];
           },
            err => console.error(err),
            // () => console.log('done loading Trace Types')
          );
        }


}
